import React from 'react';

const NotFound = () => {
    return (
        <div>
            <p>This page is not found</p>
        </div>
    );
};

export default NotFound;